import algoliasearch from 'algoliasearch'

const ALGOLIA_API_ID = '6NVYLKC6US'
const ALGOLIA_API_KEY = '1d3a14ad1c4dbe841bd48407a9d7c758'

export const ALGOLIA_CLIENT = algoliasearch(ALGOLIA_API_ID, ALGOLIA_API_KEY)

export const ALGOLIA_INDEX_MARKERS_NAME = token => `lge_predictive_locations_${token}`

export const ALGOLIA_INDEX_CIRCLES_NAME = token => `lge_predictive_circles_${token}`

export const ALGOLIA_INDEX_COUNTIES_NAME = token => `lge_predictive_counties_${token}`

export const ALGOLIA_INDEX_MARKERS = token => ALGOLIA_CLIENT.initIndex(ALGOLIA_INDEX_MARKERS_NAME(token))

export const ALGOLIA_INDEX_CIRCLES = token => ALGOLIA_CLIENT.initIndex(ALGOLIA_INDEX_CIRCLES_NAME(token))

export const ALGOLIA_INDEX_COUNTIES = token => ALGOLIA_CLIENT.initIndex(ALGOLIA_INDEX_COUNTIES_NAME(token))
